import stockService from 'common/services/stockService'
import openedInvoiceModule from '../openedInvoiceModule'
import utils from 'utils'

/**
 * 单个作废发票
 * @param  {object} invoice  发票对象
 * @param  {object} diskInfo 盘信息
 * @return {promise}         回写e税云接口
 */
let cancelInvoicePromise = function cancelInvoicePromise1(
  invoiceList,
  diskInfo
) {
  const { httpRequest } = this
  const defered = this.cancelPromise
  if (invoiceList.length === 0) {
    defered.resolve()
    return
  }
  const invoice = invoiceList.shift()
  httpRequest.post_submitCancelOvatInvoice(invoice.invoiceId).then(
    () => {
      // 开票软件调用
      window.top.TaxCore.tax.cancel(
        invoice.invType,
        invoice.invoiceCode,
        invoice.invoiceNumber,
        // 回调
        (data) => {
          if (!data) {
            defered.reject('金税盘调用失败')
            return
          }
          data = $.parseJSON(data.value)
          if (data.retcode !== '6011') {
            defered.reject(data.retmsg)
          } else {
            httpRequest.post_cancelOvatInvoice(invoice.invoiceId).then(() => {
              defered.notify(`作废成功[${invoice.invoiceNumber}]`)
              cancelInvoicePromise(invoiceList, diskInfo)
            })
          }
        },
        diskInfo.taxCode,
        diskInfo.machineNo,
        0
      )
    },
    (err) => {
      defered.reject(err)
    }
  )
}

/**
 * 发票同步 每个发票种类分页递归同步
 * @param  {object} param     同步范围参数
 * @param  {string} taxCode   税号
 * @param  {string} machineNo 机器号
 * @param  {array } fpzlArr   发票种类数组
 * @return {[type]}           [description]
 */
let synchronizePromise = function synchronize(
  param,
  taxCode,
  machineNo,
  fpzlArr,
  CheckCode
) {
  const deferred = this.$q.defer()
  const { promise } = deferred
  const { httpRequest } = this
  if (fpzlArr.length === 0) {
    if (param.totalRecNo > 0) {
      deferred.resolve(param.totalRecNo)
    } else {
      deferred.reject('没有查找到您想要同步的数据')
    }
    return promise
  }
  param.invType = fpzlArr[0] // 每次查询一种发票种类代码
  const json = {
    fpzl: param.invType,
    BeginDate: param.invoiceDateMin,
    EndDate: param.invoiceDateMax,
    fpdm: param.invoiceCode,
    fphm: param.invoiceNumber,
    PageSize: 100,
    PageIndex: param.pageIndex,
  }
  window.top.TaxCore.tax.queryInvByPage(
    json,
    // 回调
    (data) => {
      // data.value = data.value.replace(/\\/g, '/')
      // data = $.parseJSON(data.value)
      if (data.retcode !== '0') {
        deferred.reject(data.retmsg)
      } else {
        deferred.resolve(data)
      }
    },
    taxCode,
    machineNo,
    0
  )
  return promise.then((res) => {
    if (res.RecNo == 0) {
      // 处理下一个发票种类
      param.pageIndex = 1
      return synchronizePromise(
        param,
        taxCode,
        machineNo,
        fpzlArr.slice(1),
        CheckCode
      )
    }

    const postData = {
      seqNo: param.seqNo,
      diskCode: res.kpfwqh,
      ukeyCode: res.kpdh,
      invType: param.invType,
      invoiceCode: param.invoiceCode,
      invoiceDateBegin: param.invoiceDateMin,
      invoiceDateEnd: param.invoiceDateMax,
      invoiceJsonStr: JSON.stringify(res),
      invoiceNumberBegin: param.invoiceNumber,
      hardwareNo: CheckCode,
    }
    if (param.invType == '12') {
      return httpRequest.post_synVInvoiceData(postData).then((rest) => {
        param.totalRecNo += rest.data.value.successCount
        utils.loading(`正在数据同步(已同步${param.totalRecNo}张)，请耐心等待`)
        if (rest.data.value.allCount < 100) {
          param.pageIndex = 1
          // 处理下一个发票种类
          return synchronizePromise(
            param,
            taxCode,
            machineNo,
            fpzlArr.slice(1),
            CheckCode
          )
        }
        param.seqNo = rest.data.value.seqNo
        param.pageIndex += 1 // 增加分页参数
        return synchronizePromise(param, taxCode, machineNo, fpzlArr, CheckCode)
      })
    }
    return httpRequest.post_synInvoiceData(postData).then((rest) => {
      param.totalRecNo += rest.data.value.successCount
      utils.loading(`正在数据同步(已同步${param.totalRecNo}张)，请耐心等待`)
      if (rest.data.value.allCount < 100) {
        param.pageIndex = 1
        // 处理下一个发票种类
        return synchronizePromise(
          param,
          taxCode,
          machineNo,
          fpzlArr.slice(1),
          CheckCode
        )
      }
      param.seqNo = rest.data.value.seqNo
      param.pageIndex += 1 // 增加分页参数
      return synchronizePromise(param, taxCode, machineNo, fpzlArr, CheckCode)
    })
  })
}

/**
 * 打印发票
 */
let printPromise = function printPromise1(invoiceList, taxCode, MachineNo) {
  const { invoiceOpenService, printResult } = this
  const defered = this.printDefered
  if (invoiceList.length === 0) {
    defered.resolve(printResult)
    return
  }
  const invoice = invoiceList.shift()
  // 提示当前正在操作的发票
  defered.notify({
    invoice,
    index: printResult.success + printResult.error + 1,
  })
  // 打印
  invoiceOpenService.print(invoice, taxCode, MachineNo).then(
    () => {
      printResult.success += 1
      // 打印成功 下一张
      printPromise(invoiceList, taxCode, MachineNo)
    },
    (err = {}) => {
      // 打印失败不继续打印
      printResult.error += 1
      defered.reject({
        invoice,
        errormsg: err.retmsg || err,
      })
    }
  )
}

/**
 * 打印助手 - 发票
 */
let printHelperPromise = function (invoiceList) {
  const { invoiceOpenService, printResult } = this
  const defered = this.printDefered
  if (invoiceList.length === 0) {
    defered.resolve(printResult)
    return
  }
  const invoice = invoiceList.shift()
  // 提示当前正在操作的发票
  defered.notify({
    invoice,
    index: printResult.success + printResult.error + 1,
  })
  // 打印
  invoiceOpenService.printHelperPrint(invoice).then(
    () => {
      printResult.success += 1
      // 打印成功 下一张
      printHelperPromise(invoiceList)
    },
    (err = {}) => {
      // 打印失败不继续打印
      printResult.error += 1
      defered.reject({
        invoice,
        errormsg: err.retmsg || err,
      })
    }
  )
}

/**
 * 打印助手-清单
 */
let printListHelperPromise = function (invoiceList) {
  const { invoiceOpenService } = this
  const defered = this.printListDefered
  if (invoiceList.length === 0) {
    defered.resolve()
    return
  }
  const invoice = invoiceList.shift()
  // 打印
  invoiceOpenService.printHelperPrint(invoice, true).then(
    () => {
      defered.notify({
        success: true,
        msg: `清单[${invoice.invoiceNumber}]已提交打印`,
      })
      printListHelperPromise(invoiceList)
    },
    (err) => {
      // 打印失败不继续打印
      defered.notify({
        success: false,
        msg: `打印清单[${invoice.invoiceNumber}]失败`,
      })
      printListHelperPromise(invoiceList)
    }
  )
}

/**
 * 打印清单
 */
let printListPromise = function printListPromise1(
  invoiceList,
  taxCode,
  machineNo
) {
  const defered = this.printListDefered
  if (invoiceList.length === 0) {
    defered.resolve()
    return
  }
  const invoice = invoiceList.shift()
  window.top.TaxCore.tax.printInv(
    invoice.invType,
    invoice.invoiceCode,
    invoice.invoiceNumber,
    1,
    1,
    // 回调打印
    (data) => {
      if (!data) {
        // 错误只提示不阻塞
        defered.notify({
          success: false,
          msg: '金税盘调用失败',
        })
        return
      }
      data = $.parseJSON(data.value)
      if (data.retcode !== '5011') {
        defered.notify({
          success: false,
          msg: `打印清单[${invoice.invoiceNumber}]失败：${data.retmsg}`,
        })
      } else {
        defered.notify({
          success: true,
          msg: `清单[${invoice.invoiceNumber}]已提交打印`,
        })
      }
      printListPromise(invoiceList, taxCode, machineNo)
    },
    taxCode,
    machineNo,
    0
  )
}

export default class OpenedInvoiceService {
  constructor(httpRequest, $q, invoiceOpenService) {
    this.httpRequest = httpRequest
    this.$q = $q
    this.invoiceOpenService = invoiceOpenService
    printListPromise = printListPromise.bind(this)
    printPromise = printPromise.bind(this)
    printListHelperPromise = printListHelperPromise.bind(this)
    printHelperPromise = printHelperPromise.bind(this)
    cancelInvoicePromise = cancelInvoicePromise.bind(this)
    this.realUrl = REAL_URL.replace('8888', localStorage.soapPort)
  }

  /**
   * 批量、单个作废发票
   * @param  {object} selectedList 发票数组
   * @return {promise}             作废失败发票对象数组
   */
  cancelInvoiceList(selectedList, onProcess) {
    const { invoiceOpenService, $q } = this
    const defered = $q.defer()
    this.cancelPromise = defered
    const service = this
    const { promise } = defered
    if (invoiceOpenService.checkIsA9(selectedList[0].ukeyId)) {
      let resArr = []
      function cancelInvoice(invoiceList) {
        if (invoiceList.length === 0) {
          defered.resolve(resArr)
          return
        }
        const invoice = invoiceList.shift()
        service.httpRequest.get_cancelOpenInv(invoice.invoiceId).then(
          () => {
            defered.notify(`作废成功[${invoice.invoiceNumber}]`)
            resArr.push(invoice)
            cancelInvoice(invoiceList)
          },
          (err) => {
            defered.reject(err.message)
          }
        )
      }
      cancelInvoice(selectedList)
    } else {
      invoiceOpenService.checkWithDiskInfo(selectedList).then(
        (diskInfo) => {
          cancelInvoicePromise(selectedList, diskInfo, onProcess)
        },
        (err) => {
          defered.reject(err)
        }
      )
    }
    return promise
  }

  /**
     * 数据同步
     * @param  {object} param      同步参数
     * {
     *    BeginDate: 开票开始时间,
          EndDate: 开票结束时间,
          fpdm: 发票代码,
          fphm: 发票号码,
          PageSize: 每页同步数量,
          PageIndex: 当前同步页码
     * }
     * @param  {array} invTypeArr  发票种类数组
     * @return {promise}           成功条数
     */
  synchronize(param, invTypeArr) {
    const { $q } = this
    const defered = $q.defer()
    const { promise } = defered
    synchronizePromise = synchronizePromise.bind(this)
    stockService.getDiskInfo().then(
      (diskInfoStr) => {
        const diskInfo = JSON.parse(diskInfoStr)
        const userInfo = JSON.parse(localStorage.getItem('user_info'))
        if (!diskInfo.TaxCode) {
          defered.reject('未启动或未插入金税盘')
        } else if (diskInfo.TaxCode !== userInfo.sale.saleCreditCode) {
          defered.reject('当前插入设备税号和销方税号不一致')
        } else {
          defered.resolve(
            synchronizePromise(
              param,
              diskInfo.TaxCode,
              diskInfo.MachineNo,
              invTypeArr,
              diskInfo.CheckCode
            )
          )
        }
      },
      (err) => {
        defered.reject(err)
      }
    )
    return promise
  }

  /**
   * 打印发票
   * @param  {array<invoice>} invoiceList 发票列表
   * @return {promise}             打印结果
   */
  print(invoiceList) {
    const { $q, invoiceOpenService } = this
    const defered = $q.defer()
    this.printDefered = defered
    const { promise } = defered
    this.printResult = {
      success: 0,
      error: 0,
    }
    if (!invoiceOpenService.checkIsA9(invoiceList[0].ukeyId)) {
      stockService.getDiskInfo().then(
        (diskInfoJSON) => {
          const diskInfo = JSON.parse(diskInfoJSON)
          printPromise(invoiceList, diskInfo.TaxCode, diskInfo.MachineNo)
        },
        (err) => {
          defered.reject({
            invoice: invoiceList[0],
            errormsg: err.retmsg || err,
          })
        }
      )
    }
    if (invoiceOpenService.checkIsA9(invoiceList[0].ukeyId)) {
      printHelperPromise(invoiceList)
    }
    return promise
  }

  /**
   * 打印清单
   * @param  {array} invoiceList  清单发票列表
   * @return {promise}            打印结果
   */
  printList(invoiceList) {
    const { $q, invoiceOpenService } = this
    const defered = $q.defer()
    this.printListDefered = defered
    const { promise } = defered
    if (!invoiceOpenService.checkIsA9(invoiceList[0].ukeyId)) {
      stockService.getDiskInfo().then(
        (diskInfo) => {
          printListPromise(invoiceList, diskInfo.TaxCode, diskInfo.MachineNo)
        },
        (err) => {
          defered.reject(err.retmsg || err)
        }
      )
    }
    if (invoiceOpenService.checkIsA9(invoiceList[0].ukeyId)) {
      printListHelperPromise(invoiceList)
    }
    return promise
  }

  /**
   * 获取打印机名称
   * 参数非必填
   */
  getPrinterNameList(param) {
    return new Promise((resolve, rejects) => {
      let paramStr = ''
      this.httpRequest
        .post_base64DeCode({
          invData: JSON.stringify(param),
          codeType: 'encode',
        })
        .then((res) => {
          paramStr = res.data.value
          $.post({
            url: this.realUrl,
            data: {
              SID: 56,
              SIDParam: paramStr,
            },
            timeout: 30000,
          }).then(
            (data) => {
              const DECMSG = JSON.parse(data)
                .ENCMSG.replace(new RegExp('[_]', 'gm'), '+')
                .replace(new RegExp(/(\r)/g), '')
                .replace(new RegExp(/(\n)/g), '')
              this.httpRequest
                .post_base64DeCode({
                  invData: DECMSG,
                  codeType: 'decode',
                })
                .then((res) => {
                  resolve(JSON.parse(res.data.value))
                })
            },
            () => {
              rejects()
            }
          )
        })
    })
  }

  /**
   * 设置开票软件打印机
   *  printerKindName ：打印发票种类
   * printerName ： 打印机名称
   */
  setPrinterName(param) {
    return new Promise((resolve, rejects) => {
      let paramStr = ''
      this.httpRequest
        .post_base64DeCode({
          invData: JSON.stringify(param),
          codeType: 'encode',
        })
        .then((res) => {
          paramStr = res.data.value
          $.post({
            url: this.realUrl,
            data: {
              SID: 57,
              SIDParam: paramStr,
            },
            timeout: 30000,
          }).then(
            (data) => {
              const DECMSG = JSON.parse(data)
                .ENCMSG.replace(new RegExp('[_]', 'gm'), '+')
                .replace(new RegExp(/(\r)/g), '')
                .replace(new RegExp(/(\n)/g), '')
              this.httpRequest
                .post_base64DeCode({
                  invData: DECMSG,
                  codeType: 'decode',
                })
                .then((res) => {
                  resolve(JSON.parse(res.data.value))
                })
            },
            () => {
              rejects()
            }
          )
        })
    })
  }

  /**
   * 设置税控开票软件打印偏移
   *  printerKindName ：打印发票种类
   * printerName ： 打印机名称
   * printLeft ： 打印左边距
   * printTop ： 打印上边距
   */
  setPrinterParams(param) {
    return new Promise((resolve, rejects) => {
      let paramStr = ''
      this.httpRequest
        .post_base64DeCode({
          invData: JSON.stringify(param),
          codeType: 'encode',
        })
        .then((res) => {
          paramStr = res.data.value
          $.post({
            url: this.realUrl,
            data: {
              SID: 58,
              SIDParam: paramStr,
            },
            timeout: 30000,
          }).then(
            (data) => {
              const DECMSG = JSON.parse(data)
                .ENCMSG.replace(new RegExp('[_]', 'gm'), '+')
                .replace(new RegExp(/(\r)/g), '')
                .replace(new RegExp(/(\n)/g), '')
              this.httpRequest
                .post_base64DeCode({
                  invData: DECMSG,
                  codeType: 'decode',
                })
                .then((res) => {
                  resolve(JSON.parse(res.data.value))
                })
            },
            () => {
              rejects()
            }
          )
        })
    })
  }

  /**
   * 打印测试
   * InfoKind ：打印发票种类
   */
  printTest(param) {
    return new Promise((resolve, rejects) => {
      let paramStr = ''
      this.httpRequest
        .post_base64DeCode({
          invData: JSON.stringify(param),
          codeType: 'encode',
        })
        .then((res) => {
          paramStr = res.data.value
          $.post({
            url: this.realUrl,
            data: {
              SID: 58,
              SIDParam: paramStr,
            },
            timeout: 30000,
          }).then(
            (data) => {
              const DECMSG = JSON.parse(data)
                .ENCMSG.replace(new RegExp('[_]', 'gm'), '+')
                .replace(new RegExp(/(\r)/g), '')
                .replace(new RegExp(/(\n)/g), '')
              this.httpRequest
                .post_base64DeCode({
                  invData: DECMSG,
                  codeType: 'decode',
                })
                .then((res) => {
                  resolve(JSON.parse(res.data.value))
                })
            },
            () => {
              rejects()
            }
          )
        })
    })
  }
}

OpenedInvoiceService.$inject = ['httpRequest', '$q', 'invoiceOpenService']
openedInvoiceModule.service('openedInvoiceService', OpenedInvoiceService)



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/openedInvoice/service/OpenedInvoiceService.js